import { ReactNode } from "react";
import { IconButton } from "components/Molecules";
import { Card, Colors } from "swing-components";

import { COMBINED_RESTRICTIONS, translate, useShouldRestrictAdmin } from "~utils";

type ProfileCardProps = {
  header: ReactNode;
  isEditing: boolean;
  onClick: () => void;
  children: ReactNode;
};

/**
 * @description Container for the School Profile card component
 */
export function ProfileCard(props: ProfileCardProps) {
  const { header, isEditing, onClick, children } = props;

  const shouldHideEdit = useShouldRestrictAdmin(COMBINED_RESTRICTIONS.EDIT_SCHOOL_PROFILE);

  return (
    <div css={{ marginBottom: 16 }}>
      <Card>
        <div className="flex w-full justify-between mb-4">
          <h2 css={{ margin: 0 }}>{header}</h2>
          {!isEditing && !shouldHideEdit && (
            <IconButton
              iconProps={{ name: "Edit", color: Colors.blue500 }}
              aria-label={translate("SCHOOL_YEAR_EDIT_ARIA_LABEL")}
              onClick={onClick}
            />
          )}
        </div>
        {children}
      </Card>
    </div>
  );
}
